export default __webpack_public_path__ + "static/consolidating-debts-65d2aae5043cbf56a9fa055687c0b42b.webp";